import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { useHistory } from 'react-router';
import { completedRoutes, itemTypes, paymentTypes, solutionStates } from '../../../common/constants';

const activeStates = [solutionStates.executing, solutionStates.rejected];

const getItemDataByType = (item, type) => {
  if (type === itemTypes.solution) {
    const {
      price: money, state, startExecutingTime: { date },
      placeName, task: { name: taskName, id: taskId }, appealHearingTime
    } = item;
    return { money, placeName, state, date, taskName, appealHearingTime, taskId };
  } else if (type === itemTypes.expense) {
    const { amount: money, placeName, state, type, approvingTime: { date } } = item;
    return { money, placeName, state, date, type };
  } else {
    throw new Error('Unknown activity type');
  }
};

const getItemType = (item) => {
  const itemType = item.hasOwnProperty('type') ? itemTypes.expense : itemTypes.solution;
  return itemType;
};

const getFormattedDate = (date) => moment(date).format('L');

function ActivityItem(props) {
  const { item } = props;
  const { t } = useTranslation();
  const history = useHistory();
  const solutionStatusesTranslation = t('solutionStatuses', { returnObjects: true });

  const itemType = getItemType(item);
  const itemData = getItemDataByType(item, itemType);

  const getClickHandler = (state) => {
    switch (state) {
      case solutionStates.executing: {
        return () => history.push(
          completedRoutes.userActivitySolution,
          { solutionId: item.id, taskId: itemData.taskId, }
        );
      }
      case solutionStates.rejected: {
        return () => history.push(completedRoutes.userActivityDispute, { solutionId: item.id });
      }
      default:
        return () => {
        };
    }
  };

  const sign = itemType === itemTypes.solution ? '+'
    : itemData.type === paymentTypes.userToPlace ? '-' : '+';

  let { state } = itemData;
  let date = getFormattedDate(itemData.date);

  if (itemType === itemTypes.solution) {
    if (itemData.appealHearingTime !== null) {
      if (itemData.state === solutionStates.rejected) {
        state = solutionStates.rejectedAppeal;
      } else if (itemData.state === solutionStates.approved) {
        state = solutionStates.approvedAppeal;
      }
      date = getFormattedDate(itemData.appealHearingTime.date);
    }
  }

  return (
    <div className={`activity-item-cnt ${activeStates.includes(itemData.state) ? 'pointer' : ''}`}
         onClick={getClickHandler(itemData.state)}>
      <div className="top">
        <div className="secondary-info-cnt">
          <span className="secondary-info">{date}</span>
          <span className="secondary-info">{itemData.placeName}</span>
        </div>
      </div>
      <div className="item-data-cnt">
        <div className="left">
          <span className="task">{itemData.taskName || t('activities.userToPlace')}</span>
        </div>
        <div className="right">
          <div className={`status state-${state}`}>
            {solutionStatusesTranslation[state]}
          </div>
          <div className="rubble price">{sign}{itemData.money}</div>
        </div>
      </div>
    </div>
  );
}

export default ActivityItem;
